import { fromPairs } from 'lodash';
import { DISPLAY_OPTIONS, DISPLAY_MODES } from '../conf/display-options';

export default {
  namespaced: true,

  state: {
    mode: 'app',
    // Each option defaults to null
    ...fromPairs(DISPLAY_OPTIONS.map((option) => [option, null])),
    theme: null,
  },

  getters: {
    // Create a getter for each option that uses the default options for the
    // active mode if not overridden in state
    ...fromPairs(
      DISPLAY_OPTIONS.map((option) => [
        option,
        (state) =>
          state[option] === null
            ? DISPLAY_MODES[state.mode][option]
            : state[option],
      ]),
    ),
  },

  /* eslint-disable no-param-reassign */
  mutations: {
    setOptions: (state, options) => {
      Object.assign(state, options);
    },

    setMode: (state, { mode }) => {
      state.mode = mode;
    },

    setTheme: (state, { theme }) => {
      state.theme = theme || null;
    },
  },
};
